'use client';

import React from 'react';
import { Container } from '@/components/client/Container/Container';
import { Section } from '@/components/client/Section/Section';
import { HeroSection } from '@/features/client/HeroSection/HeroSection';
import { AboutUsSection } from '@/features/client/AboutUsSection/AboutUsSection';
import { LicenceSection } from '@/features/client/LicenceSection/LicenceSection';
import { CallUsSection } from '@/features/client/CallUsSection/CallUsSection';
import { AwardsSection } from '@/features/client/AwardsSection/AwardsSection';
import { RebatesSection } from '@/features/client/RebatesSection/RebatesSection';
import { OurBlogSection } from '@/features/client/OurBlogSection/OurBlogSection';
import { TestimonalsSection } from '@/features/client/TestimonalsSection/TestimonalsSection';
import { OurServicesSection } from '@/features/client/OurServicesSection/OurServicesSection';
import { ContactUsBanner } from '@/features/client/ContactUsBanner/ContactUsBanner';
import { ContactUsSection } from '@/features/client/ContactUsSection/ContactUsSection';
import { ExtraContent } from '@/features/client/Services/components/Content/ExtraContent/ExtraContent';

import clear from '@/public/images/services/air_conditioning/clear.png';
import certified from '@/public/images/services/heating/certified.png';
import pricing from '@/public/images/services/heating/pricing.png';
import customerService from '@/public/images/services/ac_installation/customer-service.png';
import customized from '@/public/images/services/heating-installation/customized.png';
import availablity from '@/public/images/services/air_conditioning/availablity.png';
import { LocationSection } from '@/features/client/LocationSection/LocationSection';

const HomePage = () => {
  return (
    <div>
      <Section variant="primary">
        <Container>
          <HeroSection />
        </Container>
      </Section>
      <CallUsSection />
      <Section variant="primary">
        <Container>
          <OurServicesSection />
        </Container>
      </Section>

      <Section variant="secondary">
        <Container>
          <ExtraContent
            data={[
              {
                title: 'Why Do Clients Trust Tytum?',
                description:
                  'There are many reasons why homeowners, business owners, and investors choose us as their go-to partner for both everyday services and large projects.',
                // image: null,
                items: [
                  {
                    title: 'Cross-service expertise',
                    image: clear,
                    description:
                      'At Tytum, we accommodate specialists from every field. We save our customers the need to juggle multiple contractors and enable them to hire a single reliable partner.',
                  },
                  {
                    title: 'Licensed professionals',
                    image: certified,
                    description:
                      'Our seasoned specialists not only bring extensive knowledge and skill to every job. They are also certified experts who follow the highest industry standards, ensuring each work is done the right way.',
                  },
                  {
                    title: 'Commitment to Quality',
                    image: customerService,
                    description:
                      'Your comfort is our priority, and we’re not happy until you are. From your first call to the final check-up, we treat your home or business with the care it deserves.',
                  },
                  {
                    title: 'Custom Solutions',
                    image: customized,
                    description:
                      'We take the time to understand your unique needs, goals, and budget before recommending the right solutions. We tailor every service to work like a charm for your individual space, plans, and lifestyle.',
                  },
                  {
                    title: 'Honest Pricing',
                    image: pricing,
                    description:
                      'We strive to earn your trust through fair quotes and honest assessments, and we only recommend services you truly need. So, you’ll always receive transparent, upfront pricing with no hidden fees.',
                  },
                  {
                    title: 'Long-term value',
                    image: availablity,
                    description:
                      'We don’t work around quick fixes and a one-size-fits-all approach. We offer personalized solutions to deliver lasting results that improve comfort and add value to your property. Hence, many of our customers stay with us for years.',
                  },
                ],
                footerText: '',
              },
            ]}
          />
        </Container>
      </Section>

      <CallUsSection />

      <Section variant="secondary">
        <Container>
          <AwardsSection />
        </Container>
      </Section>
      <Section variant="secondary">
        <Container>
          <TestimonalsSection />
        </Container>
      </Section>

      <Section variant="primary">
        <Container>
          <LocationSection />
        </Container>
      </Section>

      <Section variant="primary">
        <Container>
          <AboutUsSection />
        </Container>
      </Section>

      <Section variant="secondary">
        <Container>
          <LicenceSection />
        </Container>
      </Section>

      <Section variant="secondary">
        <Container>
          <RebatesSection />
        </Container>
      </Section>

      <Section variant="primary">
        <Container>
          <OurBlogSection />
        </Container>
      </Section>
      <Section variant="primary" styles={{ paddingTop: 0 }}>
        <Container>
          <ContactUsSection />
        </Container>
      </Section>
      <Section variant="secondary">
        <Container>
          <ContactUsBanner />
        </Container>
      </Section>
    </div>
  );
};

export default HomePage;
